import { Tooltip, Tag } from 'antd';
import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    FieldTimeOutlined
} from '@ant-design/icons';
import { InputFromUser } from '../../../../components/Input/input';

const ServiceCard = ({
    service,
    serviceIndex,
    date,
    cellData,
    isPast,
    periodInfo,
    formatTime,
    calculateDuration,
    handlePlanChange
}) => {
    const hasValue = cellData?.medicineValue &&
        cellData.medicineValue !== 'Not Started' &&
        cellData.medicineValue !== 'On Hold' &&
        cellData.medicineValue !== 'Not Taken';
    const duration = calculateDuration(service.startTime, service.endTime);
    // Use totalMinutes if available in cellData, otherwise use calculated duration
    const displayDuration = cellData?.totalMinutes ? `${cellData.totalMinutes}m` : duration;

    return (
        <div
            style={{
                background: hasValue ? '#f6ffed' : '#fff',
                border: hasValue ? '2px solid #52c41a' : `2px solid ${periodInfo.borderColor}`,
                borderRadius: '8px',
                padding: '16px',
                transition: 'all 0.3s ease',
                position: 'relative',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            }}
        >
            <div style={{
                position: 'absolute',
                top: '12px',
                right: '12px',
                display: 'flex',
                gap: '4px',
                alignItems: 'center'
            }}>
                {hasValue ? (
                    <Tooltip title="Completed">
                        <CheckCircleOutlined style={{ fontSize: '20px', color: '#52c41a' }} />
                    </Tooltip>
                ) : (
                    <Tooltip title="Pending">
                        <ClockCircleOutlined style={{ fontSize: '20px', color: '#d9d9d9' }} />
                    </Tooltip>
                )}
            </div>

            <div style={{ marginBottom: '12px', paddingRight: '30px' }}>
                <h5 style={{
                    margin: 0,
                    fontSize: '15px',
                    fontWeight: '600',
                    color: periodInfo.color,
                }}>
                    {service.serviceName || 'Unnamed Service'}
                </h5>

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginTop: '8px',
                    padding: '8px',
                    background: periodInfo.bgColor,
                    borderRadius: '6px',
                    border: `1px solid ${periodInfo.borderColor}`,
                }}>
                    <FieldTimeOutlined style={{ color: periodInfo.color, fontSize: '14px' }} />
                    <div style={{ flex: 1 }}>
                        <div style={{
                            fontSize: '13px',
                            fontWeight: '600',
                            color: '#262626',
                        }}>
                            {formatTime(service.startTime)} - {formatTime(service.endTime)}
                        </div>
                        {displayDuration && (
                            <Tag
                                color={periodInfo.color}
                                style={{
                                    marginTop: '4px',
                                    fontSize: '11px',
                                    padding: '0 6px',
                                    lineHeight: '18px'
                                }}
                            >
                                {displayDuration}
                            </Tag>
                        )}
                    </div>
                </div>
            </div>

            <InputFromUser
                placeholder="Select Medicine"
                type="singleSelect"
                name={`${service.serviceName || 'service'}-${date}`}
                onChange={newValue => handlePlanChange(serviceIndex, date, newValue)}
                value={cellData?.medicineValue || undefined}
                options={[
                    ...(cellData?.medicine.filter((item) => (typeof item === 'string' ? item : item?.value)?.trim().toUpperCase() !== 'HOLD') || []),
                    { label: '⏸️ On Hold', value: 'On Hold' },
                    { label: '❌ Not Taken', value: 'Not Taken' },
                    { label: '⏹️ Not Started', value: 'Not Started' }
                ]}
                disabled={false}
                Showlabel={false}
            />
        </div>
    );
};

export default ServiceCard;
